<template>
    <div>
        <SearchBox ref="SearchBox">
            <template slot="form">
                <div class="topChoose">
                    <span class="topSty" style="font-size: 1.1vw">人员看板</span>
                    <div class="topSty">
                        <span>全部工厂：</span>
                        <el-select v-model="fcIdSelected" placeholder="请选择工厂" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
                            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"></el-option>
                        </el-select>
                    </div>
                    <div class="topSty">
                        <span>全部车间：</span>
                        <el-select v-model="shopSelected" placeholder="请选择车间" clearable filterable @change="shopChange">
                            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value"></el-option>
                        </el-select>
                    </div>
                    <div class="topSty">
                        <el-button type="primary" @click="getPersonnelTotality">查询</el-button>
                    </div>
                    <div class="topSty" v-if="isSkip">
                        <el-button @click="getFacility">返回</el-button>
                    </div>
                </div>
            </template>
        </SearchBox>
        <SearchBox ref="SearchBox">
            <template slot="form">
                <div class="currentNum">
                    <div style="display: flex" ssssss>
                        <div style="flex: 1">
                            <p>当班维修人数</p>
                            <h3 class="Sty1 styColor1">{{ searchData.total }}</h3>
                        </div>
                        <div style="flex: 1">
                            <p>接单人数</p>
                            <h3 class="Sty1 styColor1">{{ searchData.onJob }}</h3>
                        </div>
                        <div style="flex: 1">
                            <p>接单数</p>
                            <h3 class="Sty1 styColor1">{{ searchData.takingAmount }}</h3>
                        </div>
                        <div style="flex: 1">
                            <p>当月总共单数(当月)</p>
                            <h3 class="Sty1 styColor1">{{ searchData.averageTaking }}</h3>
                        </div>
                        <div style="flex: 1">
                            <p>平均故障响应时间(当月)</p>
                            <h3 class="Sty1 styColor1">{{ searchData.averageResponseTime }}(分)</h3>
                        </div>
                        <div style="flex: 1">
                            <p>平均故障修复时间(当月)</p>
                            <h3 class="Sty1 styColor1">{{ searchData.averageRepairTime }}(分)</h3>
                        </div>
                    </div>
                </div>
            </template>
        </SearchBox>
        <div>
            <div class="currentState">
                <el-table stripe :data="tableData" style="width: 100%" highlight-current-row @current-change="userCurrentChange">
                    <el-table-column prop="userName" label="人员" align="center"></el-table-column>
                    <el-table-column prop="andonCode" label="安灯编号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="andonStatus" label="安灯状态" align="center" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.andonStatus == 'create'">待接单</span>
                            <span v-if="scope.row.andonStatus == 'wait_complete'">待完成</span>
                            <span v-if="scope.row.andonStatus == 'wait_accept'">待验收</span>
                            <span v-if="scope.row.andonStatus == 'complete'">已完成</span>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column prop="state" label="状态" align="center"> </el-table-column>-->
                    <el-table-column prop="atName" label="安灯类型" align="center"></el-table-column>
                    <el-table-column prop="fcName" label="工厂" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="shopName" label="车间" align="center"></el-table-column>
                    <el-table-column prop="sectionName" label="工段" align="center"></el-table-column>
                    <el-table-column prop="lineName" label="产线" align="center"></el-table-column>
                    <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
                    <!--<el-table-column prop="devLocation" label="区域" align="center"></el-table-column>-->
                    <el-table-column prop="repairTime" label="报修时间" align="center" width="180"></el-table-column>
                    <el-table-column prop="morAssistOne" label="协助人一" align="center"></el-table-column>
                    <el-table-column prop="morAssistTwo" label="协助人二" align="center"></el-table-column>
                    <el-table-column prop="morAssistThree" label="协助人三" align="center"></el-table-column>
                </el-table>
                <el-pagination
                    style="margin-top: 3vh"
                    background
                    @size-change="paginationChange"
                    @current-change="paginationCurrentChange"
                    :current-page="searchParams.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="searchParams.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchParams.pageCount"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      tableData: [],
      userInfo: {},
      role: {},
      ischeck: true,
      isclear: false,
      isChange: true,
      fcIdSelected: '',
      shopSelected: '',
      factoryTree: [],
      searchData: {},
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      intervalId: null,
      userManuArray: {},
      signNumberArray: {},
      signInNumber: '',
      notSignInNumber: '',
      isSkip: false
    }
  },
  computed: {
    factoryList: function () {
      var arr = []
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.factoryTree != undefined && this.factoryTree.length > 0) {
        if (this.ischeck) {
          for (var i = 0;i < this.factoryTree.length;i++) {
            for (let j = 0;j < userInfo.roles.length;j++) {
              if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                arr.push({
                  label: this.factoryTree[i].deptName,
                  id: this.factoryTree[i].deptID,
                  value: JSON.stringify(this.factoryTree[i]),
                  deptLevel: this.factoryTree[i].deptLevel,
                  parent: 0
                })
              }
            }
          }
        } else {
          for (var i = 0;i < this.factoryTree.length;i++) {
            arr.push({
              label: this.factoryTree[i].deptName,
              id: this.factoryTree[i].deptID,
              value: JSON.stringify(this.factoryTree[i]),
              deptLevel: this.factoryTree[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    shopList: function () {
      var arr = []
      if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
        var factory = JSON.parse(this.fcIdSelected)
        var shops = factory.child
        for (var i = 0;i < shops.length;i++) {
          if (shops[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: shops[i].deptName,
              id: shops[i].deptID,
              value: JSON.stringify(shops[i]),
              deptLevel: shops[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    }
  },
  destroyed () {
    // 在页面销毁后，清除计时器
    this.clear()
  },
  created () {
    this.dataRefreh()
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0;i < role.length;i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          this.isclear = true
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getData()
    },
    // 定时刷新数据函数
    dataRefreh () {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        console.log('刷新' + new Date())
        this.getPersonnelTotality() //加载数据函数
      }, 5000)
    },
    // 停止定时器
    clear () {
      clearInterval(this.intervalId) //清除计时器
      this.intervalId = null //设置为null
    },
    fcChange () {
      this.isChange = false
      this.shopSelected = ''
      this.getPersonnelTotality()
    },
    getFacility () {
      this.$router.push({
        name: 'facilitySpectaculars',
        params: {
          full: "true"
        }
      })
    },
    userCurrentChange (row) {
      var array = JSON.parse(JSON.stringify(row))
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        array['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (this.shopSelected != undefined && this.shopSelected != '') {
        array['shopCode'] = JSON.parse(this.shopSelected).deptCode
      }
      this.$router.push({
        name: 'andonOrderList',
        params: {
          userSpe: array
        }
      })
    },
    shopChange () {
      this.getPersonnelTotality()
    },
    paginationChange (val) {
      this.searchParams.pageSize = val
      this.getPersonnelPage()
    },
    paginationCurrentChange (val) {
      this.searchParams.page = val
      this.getPersonnelPage()
    },
    getPersonnelTotality () {
      let queryParams = {}
      var self = this
      if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
      }
      if (self.shopSelected != undefined && self.shopSelected != '') {
        queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
      }
      let options = {
        method: 'get',
        url: this.$api.personnelTotality,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            self.searchData = JSON.parse(JSON.stringify(response.data))
            self.searchData.averageResponseTime = self.searchData.averageResponseTime == 0 ? 0 : (self.searchData.averageResponseTime * 60).toFixed(2)
            self.searchData.averageRepairTime = self.searchData.averageRepairTime == 0 ? 0 : (self.searchData.averageRepairTime * 60).toFixed(2)
          } else {
            self.searchData = {}
            self.searchParams = {}
            self.tableData = []
          }
          self.getPersonnelPage()
        } else {
          self.searchData = {}
          self.searchParams = {}
          self.tableData = []
        }
      })
    },
    getPersonnelPage () {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page
      }
      var self = this
      if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
      }
      if (self.shopSelected != undefined && self.shopSelected != '') {
        queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
      }
      if (self.signInNumber != undefined && self.signInNumber != '') {
        queryParams['signInNumber'] = self.signInNumber
      }
      if (self.notSignInNumber != undefined && self.notSignInNumber != '') {
        queryParams['notSignInNumber'] = self.notSignInNumber
      }
      let options = {
        method: 'GET',
        url: this.$api.personnelPage,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.tableData = response.data.list
          this.searchParams.pageCount = response.data.total
        }
      })
    },
    getData () {
      var self = this
      let options = {
        method: 'GET',
        url: this.$api.departTree
      }
      this.$http.request(options).then(response => {
        this.factoryTree = response.data
        for (var i = 0;i < self.factoryTree.length;i++) {
          if (self.ischeck && self.isChange && !self.isSkip) {
            if (self.factoryTree[i].deptID == self.role.factoryId) {
              self.fcIdSelected = JSON.stringify(self.factoryTree[i])
            }
          } else if (!self.ischeck && self.isChange && !self.isSkip) {
            self.fcIdSelected = JSON.stringify(self.factoryTree[0])
          }
          //工厂看板
          if (this.$route.params.userManu != undefined && this.$route.params.userManu != '') {
            this.userManuArray = this.$route.params.userManu
            if (this.userManuArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.userManuArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.userManuArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0;j < shops.length;j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.userManuArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                      }
                    }
                  }
                }
              }
            }
          }
          //新工厂看板
          if (self.$route.params.signNumber != undefined && self.$route.params.signNumber != '') {
            self.isSkip = true
            self.signNumberArray = self.$route.params.signNumber
            let fcCodeList = []
            if (self.signNumberArray.hasOwnProperty('fcCode')) {
                fcCodeList = self.signNumberArray.fcCode.split(',')
            }
            if (fcCodeList.length > 1) {
                self.signNumberArray.fcCode = fcCodeList[0]
            }
            if (self.signNumberArray.hasOwnProperty('signName')) {
              let signName = ''
              signName = self.signNumberArray.signName
              if (signName == 1) {
                self.signInNumber = signName
              }
              if (signName == 0) {
                self.notSignInNumber = signName
              }
            }
            if (self.factoryTree[i].deptCode == self.signNumberArray.fcCode) {
              self.fcIdSelected = JSON.stringify(self.factoryTree[i])
              if (self.signNumberArray.hasOwnProperty('shopCode')) {
                var shops = JSON.parse(self.fcIdSelected).child
                for (let j = 0;j < shops.length;j++) {
                  if (shops[j].hasOwnProperty('deptCode')) {
                    if (shops[j].deptCode == self.signNumberArray.shopCode) {
                      self.shopSelected = JSON.stringify(shops[j])
                    }
                  }
                }
              }
            }
          } else {
            self.isSkip = false
          }
        }
        this.getPersonnelTotality()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.searchBox {
    display: inherit;
}

.searchBox .btnBox {
    flex: inherit !important;
}

.topChoose {
    width: 97.5%;
    height: 7vh;
    display: flex;
    border-radius: 5px;
    margin: 0vh 1vw 1vh 1vw;
}

.topSty {
    display: flex;
    margin-left: 2vw;
    align-items: center;
}

.currentNum {
    width: 98%;
    height: 7vh;
    border-radius: 4px;
    // box-shadow: 5px 6px 9px #ccc;
}

.currentTit {
    width: 100%;
    height: 7vh;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Sty1 {
    margin-top: 1.5vh;
}

.styColor1 {
    color: #8bafe3;
}

.styBgColor2 {
    background-color: #d95043;
}

.styBgColor3 {
    background-color: #6198db;
}

.currentState {
    width: 98%;
    margin: 2vh 1vw 1vh 1vw;
}
</style>
